import { fetchConToken } from '../helpers/fetch';

const EmpresasService = {
    traerPorCUIToDenominacion : (texto) => {
        return fetchConToken(`Empresas/traerPorCUIToDenominacion/${texto}`)
    },
    guardar:(empresa)=>{
        return fetchConToken(`Empresas`, empresa, "POST")
    },
    actualizar:(empresa, id)=>{
        return fetchConToken(`Empresas/${id}`, empresa, "PUT")
    },
    actualizarSeguimiento : (data)=>{
        return fetchConToken(`Empresas/seguimientoEmpresa`, data, "POST")
    },
    traerSeguimientosEmpresa: (cuit)=>{
        return fetchConToken(`Empresas/ObtenerSeguimientos/${cuit}`)
    }
}

export {EmpresasService as default}